<mat-card-content class="card-content">
  @for (filter of config; track filter; let i = $index) {
    <div class="input-wrapper">
      <!-- <ng-select
      (change)="onSelect($event, i, filter)"
      [items]="filters"
      [searchable]="false"
      [clearable]="false"
      bindLabel="label"
      bindValue="title"
      placeholder="Filter"
      >
    </ng-select> -->
      <mat-form-field *ngIf="!filter.number" class="input-field text-field">
        <input
          (keyup)="onKeyUp(no1.value, i, filter)"
          matInput
          #no1
          placeholder="Contains"
          class="input-text"
          type="text" />
      </mat-form-field>
      <mat-form-field *ngIf="filter.number" class="input-field number-field">
        <input
          (keyup)="onKeyUp('', i, filter, no2.value)"
          matInput
          #no2
          placeholder="From"
          class="input-number"
          type="text" />
      </mat-form-field>
      <mat-form-field *ngIf="filter.number" class="input-field number-field">
        <input
          (keyup)="onKeyUp('', i, filter, '', no3.value)"
          matInput
          #no3
          placeholder="To"
          class="input-number"
          type="text" />
      </mat-form-field>
      <button
        mat-flat-button
        color="success"
        class="table-button"
        (click)="delFilter(config.indexOf(filter))">
        delete
      </button>
    </div>
  }
  <div class="filter-buttons">
    <button
      mat-flat-button
      color="warn"
      class="table-button"
      (click)="clearFilters()">
      clear
    </button>
    <button
      mat-flat-button
      color="success"
      class="table-button"
      (click)="submitHandler()">
      apply
    </button>
  </div>
</mat-card-content>
